module.exports = "/packs/jcb-d856320a2dbe2687a09cce495d3623e0.png";